module.exports = __webpack_public_path__ + "static/img/preview-01.89086088.webp";